module.exports = __webpack_public_path__ + "static/media/info-icon-disable.d28474e8.png";